import React, { useState } from 'react';

function BottomSectionContainer() {
    const [hoveredColor, setHoveredColor] = useState('');

    const handleMouseEnter = (color) => {
        setHoveredColor(color);
    };

    const handleMouseLeave = () => {
        setHoveredColor('');
    };

    const handleColorClick = (color) => {
        navigator.clipboard.writeText(color);
        alert(`Copied ${color} to clipboard!`);
    };

    const squareStyles = {
        width: '100px',
        height: '100px',
        margin: '10px',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontWeight: 'bold',
        cursor: 'pointer',
    };

    const containerStyles = {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        padding: '20px',
        backgroundColor: '#fff',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        marginTop: '20px',
    };

    const colors = ['#98b3b5', '#d6c983', '#c7c0ad', '#838d63', '#b16863', '#cb924a', '#28718f', '#9f8a07'];

    return (
        <div style={containerStyles}>
            {colors.map((color, index) => (
                <div
                    key={index}
                    style={{ ...squareStyles, backgroundColor: color }}
                    onMouseEnter={() => handleMouseEnter(color)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => handleColorClick(color)}
                >
                    {hoveredColor === color && <span>{color}</span>}
                </div>
            ))}
        </div>
    );
}

export default BottomSectionContainer;
